import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  note: {
    isLoading: false,
    error: null,
  },
  apiStatus: {
    statusCode: null,
    statusText: null,
    data: {
      items: [],
    },
  },
};

export const TemplateSlice = createSlice({
  name: "Template",
  initialState: INITIAL_STATE,
  reducers: {
    fetchTemplateData: (state) => {
      state.note.isLoading = true;
    },
    fetchTemplateSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      note: {
        ...state.note,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
        data: action.payload?.data,
      },
    }),
    fetchTemplateFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      note: {
        ...state.note,
        error: action.payload?.message,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),
    clearTemplate: (state) => ({
      ...state,
      note: {
        ...state.note,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: null,
        statusText: null,
        data: {
          items: [],
        },
      },
    }),
  },
});

export const {
  fetchTemplateData,
  fetchTemplateFailure,
  fetchTemplateSuccess,
  clearTemplate,
} = TemplateSlice.actions;
export const TemplateReducer = TemplateSlice.reducer;
